import { Component, OnInit } from '@angular/core';
import { SideBarComponent } from '../shared/sidebar/side-bar-component';
import { ActivatedRoute, Router } from '@angular/router';
import { SideBarService } from '../shared/sidebar/side-bar.service';

@Component({
  selector: 'app-delivery',
  templateUrl: './delivery.component.html',
  styleUrls: ['./delivery.component.scss']
})
export class DeliveryComponent extends SideBarComponent {

  constructor(
    protected sideBar: SideBarService,
    protected router: Router,
    protected route: ActivatedRoute
  ) {
    super(sideBar,router,route);
  }
}
